import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../../common/services/customer/Actions';
import * as CustomerService from '../../../../common/services/customer/Service';
import { CustomerActionPropTypes } from '../../../../common/services/customer/Types';
import { CardDetailsDTO } from '../../../../common/types/dto/CardDetailsDTO';
import { ConfigProp, RenderPropWithProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';
import { AppThunkDispatch } from '../../../common/types';

export interface CardsProps extends ConfigProp {
    cards: CardDetailsDTO[] | undefined;
}

export interface CardsContainerProps {
}

interface ReduxStateProps {
    isCommunicating: boolean;
    customerCards: CardDetailsDTO[];
}

interface ReduxDispatchProps {
    customerActions: typeof Actions;
    customerServiceActions: CustomerService.ServiceActions;
}

interface CardsContainerState {
    cards: CardDetailsDTO[] | undefined;
}

class CardsContainer extends Component<
    CardsContainerProps &
    TranslationFuncProp &
    RenderPropWithProps<CardsProps> &
    ReduxStateProps &
    ReduxDispatchProps,
    CardsContainerState
    > {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        isCommunicating: PropTypes.bool.isRequired,
        customerCards: PropTypes.any,
        customerActions: CustomerActionPropTypes.isRequired,
        customerServiceActions: CustomerService.ServiceActionPropTypes.isRequired,
        //
        children: PropTypes.func.isRequired,
    };

    public readonly state: CardsContainerState = {
        cards: undefined,
    };

    public async componentDidMount() {
        await this.props.customerServiceActions.customerCards().then(() => {
            this.setState({
                cards: this.customerCardsConverter(this.props.customerCards),
            });
        });
    }

    public render() {
        const newProps: CardsProps = {
            cards: this.state.cards,
            config,
        };

        return this.props.children(newProps);
    }

    private customerCardsConverter(cards: CardDetailsDTO[]) {
        const newCards: CardDetailsDTO[] = [];
        cards.map((card) => {
            newCards.push({
                licensePlate: card.licensePlate,
                vin: card.vin ? card.vin : '–',
                number: card.number,
                state: card.state,
                stateCard: card.stateCard,
                type: card.type,
                dealer: card.dealer,
                validDate: card.validDate,
            });
        });
        return newCards;
    }
}

const mapStateToProps = (store: RootState) => ({
    isCommunicating: store.customerState.updateCustomer.isCommunicating,
    customerCards: store.customerState.customerCards.data,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    customerActions: bindActionCreators(Actions, dispatch),
    customerServiceActions: CustomerService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardsContainer);
